import React, { useState, useReducer, useCallback, useMemo} from 'react';
import { useNavigate } from "react-router";
import Products from './../data/product.json'
import List from './../data/list.json'
import Locale from './../data/locale.json'
import Material from './../data/material.json'
import PageContext from './Context';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';

const withPageContext = (Component) => {

  const checkObjectKeys = (objA, objB) => {
    let keyA = Object.keys(objA);
    let keyB = Object.keys(objB);
    for(let i=0;i<keyA.length;i++)
    {
      if(keyB.indexOf(keyA[i]) < 0)
        return false;
    }
    return true
  }

  const loadProductData = () => {
    
    let storedData = localStorage.getItem('productData');
    if(storedData && checkObjectKeys(JSON.parse(storedData),Products))
    {
      let initData = JSON.parse(localStorage.getItem('productData'));

      Object.keys(Products).forEach((key) => {
        if(typeof initData[key] === "undefined")
        {
          initData[key] = {
            'popularity' : 'normal',
            'demand' : 'sufficient'
          }
        }
      });
      return initData;
    } else {
      let initData = {};
      
      Object.keys(Products).forEach((key) => {
        initData[key] = {
          'popularity' : 'normal',
          'demand' : 'sufficient'
        }
      });

      if(storedData)
      {
        initData = { ...initData, ...JSON.parse(storedData) }
      }

      localStorage.setItem('productData',JSON.stringify(initData));
      return initData;
    }
  }

  const saveProductData = (state, action) => {
    state[action.key][action.target] = action.value;
    localStorage.setItem('productData',JSON.stringify(state));
    return {...state};
  }

  const loadMaterialData = () => {

    let storedData = localStorage.getItem('materialData');

    if(storedData && checkObjectKeys(JSON.parse(storedData),Material))
    {
      return JSON.parse(localStorage.getItem('materialData'));
    } else {
      let initData = {};
      
      Object.keys(Material).forEach((key) => {
        initData[key] = 0;
      });

      if(storedData)
      {
        initData = { ...initData, ...JSON.parse(storedData) }
      }

      localStorage.setItem('materialData',JSON.stringify(initData));
      return initData;
    }
  }

  const saveMaterialData = (state, action) => {
    state[action.key] = action.value;
    localStorage.setItem('materialData',JSON.stringify(state));
    return {...state};
  }


  const loadWorkshop = () => {

    let storedData = localStorage.getItem('workshop');
    if(localStorage.getItem('workshop') && storedData.workshops)
    {
      let initData = JSON.parse(localStorage.getItem('workshop'));
      if(initData.workshops.length < 4)
      {
        initData.workshops = [
          {
            rank : 1,
            schedule : []
          },
          {
            rank : 1,
            schedule : []
          },
          {
            rank : 1,
            schedule : []
          },
          {
            rank : 1,
            schedule : []
          }
        ]
      }

      
      return initData;
    } else {
      
      
      let initData = {
        morale : 1,
        rank : 1,
        workshops : [
          {
            rank : 1,
            schedule : []
          },
          {
            rank : 1,
            schedule : []
          },
          {
            rank : 1,
            schedule : []
          },
          {
            rank : 1,
            schedule : []
          }
        ]
      }

      if(storedData)
      {
        initData = { ...initData, ...JSON.parse(storedData) }
      }

      if(initData.workshops.length < 4)
      {
        initData.workshops = [
          {
            rank : 1,
            schedule : []
          },
          {
            rank : 1,
            schedule : []
          },
          {
            rank : 1,
            schedule : []
          },
          {
            rank : 1,
            schedule : []
          }
        ]
      }

      localStorage.setItem('workshop',JSON.stringify(initData));
      return initData;
    }
  }

  const saveWorkshop = (state, action) => {
    let data = JSON.parse(JSON.stringify(state));
    if(action.key === "rank")
    {
      data.workshops[action.target][action.key] = action.value
    } else if(action.key === "morale")
    {
      data[action.key] = action.value;
    } else if(action.key === "addSchedule")
    {
      
      let arr = data.workshops[action.target].schedule.concat();
      arr.push(action.value);
      data.workshops[action.target].schedule = arr;
    } else if(action.key === "removeSchedule")
    {
      
      let arr = data.workshops[action.target].schedule.concat();
      arr.splice(action.value, 1);
      data.workshops[action.target].schedule = arr;
    }

    localStorage.setItem('workshop',JSON.stringify(data));
    return {...data};
  }


  const saveProductPrice = (state, action) => {
    let newData = {...state};

    Object.keys(Products).forEach((key) => {
      let baseValue = Products[key].value[action.currentWorkshop.rank] ? Products[key].value[action.currentWorkshop.rank] : Math.floor(Products[key].value[1] * (1 + 0.1 * (action.currentWorkshop.rank - 1)));
      newData[key] = Math.floor(
        baseValue*
        List.Popularity[action.product[key].popularity].rate*
        List.Demand[action.product[key].demand].rate*
        (action.workshop.morale*0.01+1)
      );
      if(action.bonusItem.indexOf(key) > -1)
      newData[key] = newData[key]*2;
    });

    return newData;
  }

  const saveProductReady = (state,action) => {

    let newData = {...state};
    
    Object.keys(Products).forEach((key) => {
      let data = Products[key];
      let bool = true;
  
      Object.keys(data.material).forEach((material) => {
        if(data.material[material] > action.material[material])
          bool = false;
      })

      newData[key] = bool
    });

    return newData;
  }

  const loadSortPreset = () => {
    if(localStorage.getItem('sortPreset'))
    {
      return JSON.parse(localStorage.getItem('sortPreset'));
    } else {
      
      let initData = {
        sortBy : `key`,
        order : `asc`,
        showReadyOnly : false
      }
      localStorage.setItem('sortPreset',JSON.stringify(initData));
      return initData;
    }
  }

  const saveSortPreset = (state, action) => {
    state[action.key] = action.value;
    localStorage.setItem('sortPreset',JSON.stringify(state));
    return {...state};
  }


  const saveProductBonus = (state, action) => {
    if(action.currentSchedule.length === 0)
    {
      return []
    } else {
      
      let latestItem = Products[action.currentSchedule[action.currentSchedule.length - 1]];
      let arr = Object.keys(Products).filter((key) => {
        let bonus = false;
        Products[key].type.forEach((type) => {
          if(latestItem.type.indexOf(type) > -1 && key !== action.currentSchedule[action.currentSchedule.length - 1])
            bonus = true
        })
        return bonus
      });

      return arr
    }
  }

  const DEFAULT_LANG = "ja";

  const loadLang = (pathLang) => {
    if(localStorage.getItem('langPreset') && pathLang === "")
    {
      return localStorage.getItem('langPreset');
    } else if(pathLang !== ""){
      localStorage.setItem('langPreset',pathLang);
      return pathLang;
    } else {
      localStorage.setItem('langPreset',DEFAULT_LANG);
      return DEFAULT_LANG;    
    }
  }

  const saveLang = (state, action) => {
    
    localStorage.setItem('langPreset',action.value);
    return action.value;
  }



  const WrapperComponent = (props) => {
    let navigate = useNavigate();
    const pathLang = props.lang;

    const [ lang, setLang ] = useReducer(saveLang,loadLang(pathLang))

    const [ workshop, setWorkshop] = useReducer(useCallback(saveWorkshop,[]),null,loadWorkshop);
    const [ productData, setProductData] = useReducer(saveProductData,null,loadProductData);
    const [ materialData, setMaterialData] = useReducer(saveMaterialData,null,loadMaterialData);
    const [ sortPreset, setSortPreset] = useReducer(saveSortPreset, null, loadSortPreset);
    
    const [ currentWorkshop, setCurrentWorkshop ] = useState(0);
    
    const [ productReadyData, setProductReadyData] = useReducer(saveProductReady,saveProductReady({},{material:materialData}));
    const [ productBonusData, setProductBonusData] = useReducer(saveProductBonus,saveProductBonus([],{currentSchedule:workshop.workshops[currentWorkshop].schedule}));
    const [ productPriceData, setProductPriceData] = useReducer(saveProductPrice,
      saveProductPrice({},{
        workshop : workshop,
        currentWorkshop : workshop.workshops[currentWorkshop],
        product: productData,
        bonusItem: productBonusData
      }));
    const scheduleData = useMemo(() => {
      let tempData = [{
        total : 0,
        items : []
      },{
        total : 0,
        items : []
      },{
        total : 0,
        items : []
      },{
        total : 0,
        items : []
      }]

      for(let i=0;i<4;i++)
      {
        let currentSchedule = workshop.workshops[i].schedule;

        currentSchedule.forEach((item,index) => {
          let hasBonus = false;
          if(index > 0)
          {
            let previousItem = Products[currentSchedule[index - 1]];
            previousItem.type.forEach((type) => {
              if(Products[item].type.indexOf(type) > -1 && item !== currentSchedule[index - 1])
                hasBonus = true
            })
          }
    
          let baseValue = Math.floor(Products[item].value[workshop.workshops[i].rank] ? Products[item].value[workshop.workshops[i].rank] : Math.floor(Products[item].value[1] * (1 + 0.1 * (workshop.workshops[i].rank - 1))));
          let price = Math.floor(baseValue*List.Popularity[productData[item].popularity].rate*List.Demand[productData[item].demand].rate*(workshop.morale*0.01+1))*(hasBonus ? 2 : 1);

          tempData[i].total += price;

          tempData[i].items.push({
            hasBonus : hasBonus,
            price : price
          });
        });
      }

      return tempData;

    },[ workshop, productData ])
    

    useEffect(() => {
      if(pathLang !== lang)
      {
        if(pathLang !== "" && Object.keys(Locale).indexOf(pathLang) > -1)
          setLang({value:pathLang});
        else
          navigate(`/${Locale[lang].code}`)
      }
    },[pathLang,lang,navigate])

    useEffect(() => {
      setProductReadyData({
        material:materialData
      })
    },[materialData])

    useEffect(() => {
      setProductBonusData({
        currentSchedule:workshop.workshops[currentWorkshop].schedule
      });
    },[workshop,currentWorkshop])

    useEffect(() => {
      setProductPriceData({
        workshop : workshop,
        currentWorkshop : workshop.workshops[currentWorkshop],
        product: productData,
        bonusItem: productBonusData
      })
    },[workshop,currentWorkshop,productData,productBonusData]);

    //console.log('4小時 :' +Object.keys(Products).filter((key) => Products[key].crafttime === 4).length);
    //console.log('6小時 :' +Object.keys(Products).filter((key) => Products[key].crafttime === 6).length);
    //console.log('8小時 :' +Object.keys(Products).filter((key) => Products[key].crafttime === 8).length);

    const productList = useMemo(() => {
      let list = Object.keys(Products);
      
      return list.filter((item) => {
        if(sortPreset.showReadyOnly)
          return productReadyData[item]
        else
          return true
      }).sort((a, b) => {
        if(sortPreset.sortBy === "key")
        {
          return sortPreset.order === "asc" ? Products[a].id - Products[b].id : Products[a].id > Products[b].id ? -1 : 1;
        }
        if(sortPreset.sortBy === "value")
        {
          return sortPreset.order === "asc" ? 
          Products[a].value[workshop.rank] - Products[b].value[workshop.rank] : 
          Products[a].value[workshop.rank] > Products[b].value[workshop.rank] ? -1 : 1;
        }
        if(sortPreset.sortBy === "price")
        {
          return sortPreset.order === "asc" ? 
            productPriceData[a] - productPriceData[b] : 
            productPriceData[a] > productPriceData[b] ? -1 : 1;
        }
        if(sortPreset.sortBy === "time")
        {
          return sortPreset.order === "asc" ? 
            Products[a].crafttime - Products[b].crafttime : 
            Products[a].crafttime > Products[b].crafttime ? -1 : 1;
        }
        if(sortPreset.sortBy === "revenuePerHour")
        {
          return sortPreset.order === "asc" ? 
            productPriceData[a] / Products[a].crafttime - productPriceData[b] / Products[b].crafttime : 
            productPriceData[a] / Products[a].crafttime > productPriceData[b] / Products[b].crafttime ? -1 : 1;
        }
        if(sortPreset.sortBy === "popularity")
        {
          let order = ["low","normal","high","very-high",]
          let aOrder = order.indexOf(productData[a].popularity);
          let bOrder = order.indexOf(productData[b].popularity);

          return sortPreset.order === "asc" ? aOrder - bOrder : aOrder > bOrder ? -1 : 1;
        }

        if(sortPreset.sortBy === "demand")
        {
          let order = ["overflowing","surplus","sufficient","insufficient","nonexistent",]
          let aOrder = order.indexOf(productData[a].demand);
          let bOrder = order.indexOf(productData[b].demand);
          return sortPreset.order === "asc" ? aOrder - bOrder : aOrder > bOrder ? -1 : 1;
        }


        return a - b;
      })

    },[sortPreset,productPriceData,productData,workshop,productReadyData]);



    return(
    <PageContext.Provider value={{
      workshop: workshop,
      setWorkshop : setWorkshop,
      productData : productData,
      setProductData : setProductData,
      materialData : materialData,
      setMaterialData : setMaterialData,
      productPriceData : productPriceData,
      productList : productList,
      sortPreset : sortPreset,
      setSortPreset : setSortPreset,
      productReadyData : productReadyData,
      currentWorkshop : currentWorkshop,
      setCurrentWorkshop : setCurrentWorkshop,
      productBonusData : productBonusData,
      scheduleData : scheduleData,
      lang : lang, 
      setLang : setLang
    }}>
      <HelmetProvider>
        <Component {...props}/>
      </HelmetProvider>
    </PageContext.Provider>)
  }

  return WrapperComponent;
}

export default withPageContext;